import { useEffect, useState, useCallback } from 'react';
import { useStore } from './useStore';
import useTicket from './useTicket';
import filter from 'lodash/filter';
import unionWith from 'lodash/unionWith';
import find from 'lodash/find';
import reduce from 'lodash/reduce';

const usePrice = () => {
  const [state, dispatch] = useStore();
  const { clientState, tickets, fares, deliveryPrice } = state;

  const totalPrice = () => {
    // console.log('tickets', tickets);
    const quantities = unionWith(
      {}, clientState.tq, clientState.iq,
      (a, b) => b === null ? a : undefined
    );
    let tP = reduce(quantities, (acc, cur) => {
      const tix = find(fares, o => o.id === cur.id);
      if (tix) {
        const subTotalPrice = parseFloat(tix.price) * parseInt(cur.quantity);
        return acc + subTotalPrice;
      }
      return acc;
    }, 0);
    tP + deliveryPrice;
    return tP.toFixed(2);
  }

  // const adultPrice = () => {
  //   const objs = filter(quantities, q => { return q.id === 'adult' || q.id === 'group_adult' });
  //   const obj = find(objs, q => { return parseInt(q.quantity) > 0 });
  //   const price = obj && find(fares, f => { return f.id === obj.id });
  //   return obj ? price.price : 0;
  // }

  // const childPrice = () => {
  //   const objs = filter(quantities, q => { return q.id === 'child' || q.id === 'group_child' });
  //   const obj = find(objs, q => { return parseInt(q.quantity) > 0 });
  //   const price = obj && find(fares, f => { return f.id === obj.id });
  //   return obj ? price.price : 0;
  // }

  // const savings = () => {
  //   const packageTix = reduce(quantities, (acc, cur) => {
  //     const tix = find(fares, o => o.id === cur.id);
  //     const subTotalPrice = parseFloat(tix.price) * parseInt(cur.quantity);
  //     return acc + subTotalPrice;
  //   }, 0);
  // }

  // export const prices = (quantities, fares) => {
  //   console.log('quantities', quantities);
  //   console.log('fares', fares);
  //   return quantities.reduce((acc, cur) => {
  //     const tix = fares.find(o => o.id === cur.id);
  //     const subTotalPrice = parseFloat(tix.price) * cur.quantity;
  //     return acc + subTotalPrice;
  //   }, 0);
  // }
  return {
    totalPrice,
    // adultPrice,
    // childPrice,
    // savings
  }
}

export default usePrice;
